/** Mapeamento rota → módulo de licença (ZenAPI). */
export const ROTA_MODULO = [
  { prefix: '/fiscal', modulo: 'MOD_NFE' },
  { prefix: '/tax-groups', modulo: 'MOD_NFE' },
  { prefix: '/stock-movement', modulo: 'MOD_ESTOQUE' },
  { prefix: '/stock-transfers', modulo: 'ADD_MULTI_ESTOQUE' },
  { prefix: '/stock-locations', modulo: 'ADD_MULTI_ESTOQUE' },
  { prefix: '/stock-location-transfers', modulo: 'ADD_MULTI_ESTOQUE' },
  { prefix: '/reports/estoque-situacao', modulo: 'MOD_ESTOQUE' },
  { prefix: '/reports/estoque-disponibilidade', modulo: 'MOD_ESTOQUE' },
  { prefix: '/reports/planejamento-compras', modulo: 'MOD_ESTOQUE' },
  { prefix: '/suppliers', modulo: 'MOD_FORNECEDORES' },
  { prefix: '/transportadoras', modulo: 'MOD_FORNECEDORES' },
  { prefix: '/pre-vendas', modulo: 'ADD_PREVENDA' },
  { prefix: '/reports/zenpay', modulo: 'ADD_ZENPAY' },
];

export const MODULO_NOMES = {
  MOD_NFE: 'NF-e',
  MOD_ESTOQUE: 'Estoque',
  MOD_FORNECEDORES: 'Fornecedores',
  ADD_PREVENDA: 'Pré-venda',
  ADD_ZENPAY: 'ZenPay',
  ADD_WHATSAPP: 'WhatsApp',
  ADD_MULTI_ESTOQUE: 'Multi estoque',
  ADD_EMPRESA: 'Empresa adicional',
  ADD_AUTOATENDIMENTO: 'Auto atendimento',
  GESTAO_BASE: 'PDV + Gestão',
};

export function rotaExigeModulo(pathname) {
  const path = pathname || '';
  const ordenado = [...ROTA_MODULO].sort((a, b) => b.prefix.length - a.prefix.length);
  for (const { prefix, modulo } of ordenado) {
    if (path === prefix || path.startsWith(`${prefix}/`)) return modulo;
  }
  return null;
}

export function isModuloAtivo(modulos, codigo) {
  if (!codigo) return true;
  if (!Array.isArray(modulos) || modulos.length === 0) return true;

  const item = modulos.find(
    (m) => String(m.codigo || m.Codigo || '').toUpperCase() === codigo.toUpperCase()
  );
  if (!item) return false;
  if (item.ativo === false || item.Ativo === false) return false;
  const qtd = Number(item.quantidade ?? item.Quantidade ?? 1);
  if (codigo === 'ADD_AUTOATENDIMENTO' || codigo === 'ADD_PDV_ADICIONAL' || codigo === 'ADD_MULTI_ESTOQUE') {
    return qtd > 0;
  }
  return true;
}

export function nomeModulo(codigo) {
  return MODULO_NOMES[codigo] || codigo;
}

export function rotaPermitida(pathname, modulos) {
  const codigo = rotaExigeModulo(pathname);
  return isModuloAtivo(modulos, codigo);
}
